import Repository from './Repository';

const resource = 'api/preLoginInfo';

export default {
  get(): Promise<any> {
    return Repository.get(resource);
  },
};
